// "lunes, 14 de septiembre de 2026, 7:03 p. m." in Bogotá time. The hour is on
// a 12-hour clock, so the day period has to be there: without it 19:03 read as
// "07:03", i.e. the morning.
export const formatTimelineDate = (dateInput) => {
  if (!dateInput) return "";
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (Number.isNaN(date.getTime())) return "";

  const parts = new Intl.DateTimeFormat("es-CO", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: "America/Bogota",
  }).formatToParts(date);
  const part = (type) => parts.find((p) => p.type === type)?.value || "";

  // es-CO separates "p. m." with non-breaking spaces; plain spaces read the same
  // and keep the string predictable.
  const dayPeriod = part("dayPeriod").replace(/\s+/g, " ").trim();
  return `${part("weekday")}, ${part("day")} de ${part("month")} de ${part("year")}, ${part("hour")}:${part("minute")}${dayPeriod ? ` ${dayPeriod}` : ""}`;
};
